module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-info-wrapper"
  }, [_c('h3'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺电话"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "value": '+' + _vm.form.phone_code,
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "t-center",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示类别"
    }
  }, [_c('el-switch', {
    attrs: {
      "value": _vm.form.display_product_tag ? true : false
    },
    on: {
      "change": function($event) {
        return _vm.handleSwitch('display_product_tag', $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示购物车"
    }
  }, [_c('el-switch', {
    attrs: {
      "value": _vm.form.display_shop_cart ? true : false
    },
    on: {
      "change": function($event) {
        return _vm.handleSwitch('display_shop_cart', $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.form.display_shop_cart == 1) ? _c('el-form-item', {
    attrs: {
      "label": "运费"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.permanent_transport_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "permanent_transport_fee", $$v)
      },
      expression: "form.permanent_transport_fee"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.display_shop_cart == 1) ? _c('el-form-item', {
    attrs: {
      "label": "免运费金额"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.free_transport_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "free_transport_fee", $$v)
      },
      expression: "form.free_transport_fee"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d475d0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/info.vue
// module id = 811
// module chunks = 1